import { ElementStatus } from '../components/rule-element/types';
export const convertElementStatusToBooleanStatus = status => {
  switch (status) {
    case ElementStatus.GeneratedAll:
    case ElementStatus.Generated:
    case ElementStatus.Passed:
      return true;
    case ElementStatus.Warning:
    case ElementStatus.Failed:
      return false;
    default:
      return false;
  }
};
//# sourceMappingURL=convert-element-statuts-to-boolean-status.js.map